import React, {Component} from 'react';
import FontAwesome from 'react-fontawesome';
import './stage.css';

export default class ScrollButton extends Component {
  constructor(props) {
    super(props);
    this.state = {active: false}
    this.trigger = this.trigger.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  componentWillMount() {
    window.addEventListener('keydown', this.handleKeyDown);
  }
  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }
  handleKeyDown(event) {
    if(event.key.toLowerCase() === `arrow${this.props.direction}`) {
      event.preventDefault();
      this.trigger();
    }
  }
  handleClick(event) {
    event.preventDefault();
    this.trigger();
  }
  trigger() {
    if(!this.state.active) {
      this.props.onTrigger();
      this.setState({active: true},() => {
        window.setTimeout(() => {
          this.setState({active: false});
        }, 500);
      });
    }
  }
  render() {
    return (
      <div className={`scroll-button scroll-button-${this.props.direction}`} onClick={this.handleClick}>
        <FontAwesome name={`arrow-${this.props.direction}`} size={this.state.active ? '3x' : '2x'} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/booth-preview/stage/scroll-button.js